import  React from "react";
import _ from "lodash";
import classnames from "classnames";
import styles from  "./ManageTacs.module.scss";
import Tac from "../../types/Tac";
import Guest from "../../types/Guest";
import LogoContainer from "../LogoContainer";
import ActionLink from "../ActionLink";
import { DeleteTacIcon } from "../Icons/DeleteTac";
import { ApproveTacIcon } from "../Icons/ApproveTac";
import { BlockUserIcon } from "../Icons/BlockUser";
import Img from '../Img'

export interface ManageTacsProps {
    gallery_display_name: string;
    tacs: ManageTacItemProps[];
    tour?: boolean;
}

export interface ManageTacItemProps {
    tac: Tac;
    is_quarantined: boolean;
    is_low_res: boolean;
    guest: Guest;
    onDelete: () => void;
    onBlock: () => void;
    onApprove: () => void;
}

export const ManageTacItem = (props: ManageTacItemProps) => {
    const classes = classnames(styles['manage-tacs__item'], {
      [styles['manage-tacs__item--quarantined']]: props.is_quarantined && !props.is_low_res,
      [styles['manage-tacs__low-res--quarantined']]: props.is_quarantined && props.is_low_res,
    });

    return (
        <li className={classes}>
            <div className={styles["manage-tacs__guest"]}>
                <p>
                    <span className={styles["manage-tacs__label"]}>Phone Number:</span>
                    { props.guest.prettyPhone() }
                </p>

                <p>
                    <span className={styles["manage-tacs__label"]}>Name:</span>
                    {props.guest.full_name}
                </p>
            </div>

            <div className={styles["manage-tacs__lower-container"]}>
                {props.tac.image && (props.tac.image.optimized || props.tac.image.original) && (
                    <Img className={styles["manage-tacs__image"]} size="240px" renditions={props.tac.image.optimized || [props.tac.image.original]} />
                )}
                {props.tac.note && props.tac.note.text && (
                    <p className={styles["note-text"]}>{props.tac.note.text}</p>
                )}

                <div className={styles["manage-tacs__icon-container"]}>
                    
                    <div className={styles["block-user-container"]}> 
                        <div className={styles["block-sender__icon"]}>            
                            <BlockUserIcon />
                            <div>Block<br/>Sender</div> 
                        </div>          

                        <ActionLink onClick={props.onBlock} className={styles["manage-tacs__icon"]}>
                            YES<br/>BLOCK                                   
                        </ActionLink>
                    </div>
                                  
                    <ActionLink onClick={props.onDelete} className={styles["manage-tacs__icon"]}>
                        <DeleteTacIcon />
                        Delete<br/><span className={styles["icon-secondary-note"]}>remove forever</span>
                    </ActionLink>

                    {props.is_quarantined &&
                        <ActionLink onClick={props.onApprove} className={styles["manage-tacs__icon"]}>
                            <ApproveTacIcon />
                            Approve<br/><span className={styles["icon-secondary-note"]}>send to gallery</span>
                        </ActionLink>
                    }
                </div>
            </div>
        </li>
    );
};

export const ManageTacs = (props: ManageTacsProps) => {
    return (
        <div className={styles["manage-tacs"]}>
            <LogoContainer />

            <h1>Submissions to <span>{props.gallery_display_name}</span></h1>

            {props.tour && (
                <div className={styles["manage-tacs-tour"]}>
                    <p>Here you can approve tacs that were caught in our content filters, delete invidual tacs, or block guests forever.</p>
                    <p>Looks like somebody sent in a questionable tac. Approve it to see it in your gallery or delete it for good.</p>
                </div> 
            )}

            <ul className={styles["manage-tacs__list"]}>
                {_.map(props.tacs, (tac) => {
                    if (tac.guest.blocked || tac.tac.state === "DELETED") {
                        return null;
                    }
                    return <ManageTacItem key={tac.tac.name} {...tac} />
                })}
            </ul>
        </div>
    );
};
